import InitDataMock from '@/mocks/init-data-mock'
import HistoryMock from '@/mocks/history-mock'
import AlertHistoryMock from '@/mocks/alert-history-mock'
import RainRuiHistoryMock from '@/mocks/rain-rui-history-mock'
import SummeryMock from '@/mocks/summery-mock'
import PresentMock from '@/mocks/present-mock'
import WeatherWarningHistoryMock from '@/mocks/weather-warning-history-mock'
import WeatherWarning2Mock from '@/mocks/weather-warning2-mock'
import WeatherWarningHistory2Mock from '@/mocks/weather-warning-history2-mock'
import NewsMock from '@/mocks/news-mock'

export default async () => {
  const initData = new InitDataMock()
  const history = new HistoryMock()
  const alertHistory = new AlertHistoryMock()
  const rainRuiHistory = new RainRuiHistoryMock()
  const summary = new SummeryMock()
  const present = new PresentMock()
  const weatherWarningHistory = new WeatherWarningHistoryMock()
  const weatherWarning2 = new WeatherWarning2Mock()
  const weatherWarningHistory2 = new WeatherWarningHistory2Mock()
  const news = new NewsMock()

  await initData.loaded
  await history.loaded
  await alertHistory.loaded
  await rainRuiHistory.loaded
  await summary.loaded
  await present.loaded
  await weatherWarningHistory.loaded
  await weatherWarning2.loaded
  await weatherWarningHistory2.loaded
  await news.loaded

  return {
    initData,
    history,
    alertHistory,
    rainRuiHistory,
    summary,
    present,
    weatherWarningHistory,
    weatherWarning2,
    weatherWarningHistory2,
    news,
  }
}
